import styled from 'styled-components';

const JobGeneralWrapper = styled.div`
  height: 100%;
  .jobs-content { 
    padding: 1em 1em 2.5em;
    max-width: 1600px;
    margin: 0 auto;
    box-sizing: border-box;
    height: calc(100% - 62px);
  }

  .jobs-table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid ${p => p.theme.color.border};
    border-radius: 6px;
    text-align: left;
    margin-top: 1.8em;
    overflow: hidden;
    table-layout: fixed;
    .event-in-process {
      cursor: default;
      text-align: center;
      color: ${p => p.theme.color.label};
    }
    thead {
      background-color: ${p => p.theme.color.background};
    }
    tbody tr {
      cursor: pointer;
    }
    th {
      font-weight: normal;
      max-width: 160px;
      font-size: 14px;
      border-collapse: collapse;
      color: ${props => props.theme.color.label};      
      border-right: 1px solid ${p => p.theme.color.border};
      height: 50px;      
    }
    td {
      height: 60px;      
      border-right: 1px solid ${p => p.theme.color.border};
      border-top: 1px solid ${p => p.theme.color.border};
      /* ──── Colors by status ───────────────────────────────────────────────────────────────────── */
      &.sent, &.delivered, &.done {
        color: ${p => p.theme.color.successGreen};
      }
      &.error {
        color: ${p => p.theme.color.error};
      }
      &.unknownphone, &.appnotinstall, &.missingnn, &.inprocess {
        color: ${p => p.theme.color.label};
      }
    }
    td, th {
      padding: 5px 1.5%;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      &:last-child {
        border-right: none;
        box-sizing: border-box;
      }
      @media all and (min-width: 1050px){
        padding: 5px 16px;
      }
    }
  }
  p {
    margin: 0;
  }    

  .sub-title {
    font-size: .85em;
    color: ${p => p.theme.color.label};
  }
`;


export default {
  JobGeneralWrapper
};